import { render, staticRenderFns } from "./AdminInitial.vue?vue&type=template&id=60f28b4f"
import script from "./AdminInitial.vue?vue&type=script&lang=js"
export * from "./AdminInitial.vue?vue&type=script&lang=js"
import style0 from "./AdminInitial.vue?vue&type=style&index=0&id=60f28b4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports